// store/modules/filters/usersPageFilter.js

const state = {
    filterBlock: {},
    selectedFilter: { text: 'Active', value: 1 },
    countUser: 50,
    selectedTab: 'Customers',
    chosenPage: 1,
};

const mutations = {
    setSelectedFilter(state, filter) {
        state.selectedFilter = filter;
    },
    setCountUser(state, countUser) {
        state.countUser = countUser;
    },
    setSelectedTab(state, tab) {
        state.selectedTab = tab;
    },
    setFilterBlock(state, filter) {
        state.filterBlock = filter;
    },
    setChosenPage(state, chosenPage) {
        state.chosenPage = chosenPage;
    },
};

const actions = {
    updateSelectedFilter({ commit }, filter) {
        commit('setSelectedFilter', filter);
    },
    updateCountUser({ commit }, countUser) {
        commit('setCountUser', countUser);
    },
    updateSelectedTab({ commit }, tab) {
        commit('setSelectedTab', tab);
    },
    updateFilterBlock({ commit }, filter) {
        commit('setFilterBlock', filter);
    },
    updateChosenPage({ commit }, chosenPage) {
        commit('setChosenPage', chosenPage);
    },
};

const getters = {
    getFilterBlock: (state) => state.filterBlock,
    getSelectedFilter: (state) => state.selectedFilter,
    getCountUser: (state) => state.countUser,
    getSelectedTab: (state) => state.selectedTab,
    getChosenPage: (state) => state.chosenPage,

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};